import React, { useState } from 'react';
import '../../styles/jisdropdown.css';

function JisDropdown({ 
  label, 
  required = false, 
  value, 
  onChange, 
  name, 
  placeholder = 'Select...', 
  options = [] 
}) {
  const [touched, setTouched] = useState(false);

  const isInvalid = required && touched && !value;

  return (
    <div className="select-group">
      <label htmlFor={name}>
        {label} {required && <span className="required">*</span>}
      </label>
      <select
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={() => setTouched(true)}
        className={isInvalid ? 'invalid' : ''}
      >
        <option value="">{placeholder}</option>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      {isInvalid && <span className="error-msg">This field is required.</span>}
    </div>
  );
}

export default JisDropdown;
